import { render } from "./Notifications.vue?vue&type=template&id=440261ac&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

import "./Notifications.vue?vue&type=style&index=0&id=440261ac&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-440261ac"],['__file',"src/containers/event/eventSettings/components/Notifications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "440261ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('440261ac', __exports__)) {
    api.reload('440261ac', __exports__)
  }
  
  module.hot.accept("./Notifications.vue?vue&type=template&id=440261ac&scoped=true", () => {
    api.rerender('440261ac', render)
  })

}


export default __exports__